/*=========================================================================================
  File Name: moduleCustomActions.js
  Description: Custom Module Actions
==========================================================================================*/

import axios from "@/axios.js"

export default {
  // 커스텀 문제집 타입 리스트
  // response.data.data: [{"id": 2,"name": "첫번째 타입입니다.","create_time": "2025-11-10 14:14:54.756938","update_time": "2025-11-10 14:14:54.756938"}]
  getWorkbookTypeList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/workbook/workbook_type_list")
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_WORKBOOK_TYPE_LIST', response.data.data)
            resolve(response.data.data)
            return
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 커스텀 문제집 타입 추가
  // payload: {"name": "첫번째 타입입니다."}
  // response.data.data: "data": {"id": 5}
  addWorkbookType(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/workbook/workbook_type", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data)
          return
        }
        reject(response)          
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 커스텀 문제집 리스트
  // response.data.data = [{"id": 4,"user_id": 1,"type": 1,"title": "문제집 이름을 입력하세요.","subject_type_id": 1,"subject_detail_type_id": 0,"subject_key": "2022100101","grade_id": 12,"target_grade_ids": [10,11,12],"curriculum_year": 2022,"school_type": 3,"display": null,"source": "참고할만한 어쩌구 - 이건 논의가 필요할듯","recommendation": null,"create_time": "2025-11-10 15:20:59.539702","update_time": "2025-11-10 15:20:59.539702"},]
  getWorkbookList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/workbook/workbook_title_list")
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_WORKBOOK_LIST', response.data.data)
            resolve(response.data.data)
            return
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 커스텀 문제집 생성
  // payload: {"id": 1,"type": 1,"title": "문제집 이름을 입력하세요.","subject_type_id": 1,"subject_detail_type_id": 0,"subject_key": "2022100101","grade_id": 11,"target_grade_ids": [10,11,12],"curriculum_year": 2022,"source": "출처 정보(선택입력기능)"}
  // response.data.data: {"workbook_title_id": 4}
  createWorkbook(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/workbook/workbook_title", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data)
          return
        }
        reject(response)          
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 커스텀 기존 문제집 데이터 수정
  // payload: {"id": 1,"type": 1,"title": "문제집 이름을 변경합니다.","subject_type_id": 1,"subject_detail_type_id": 0,"subject_key": "2022100101","grade_id": 11,"target_grade_ids": [10,11,12],"curriculum_year": 2022,"source": "소스도 변경 가능합니다."}
  editWorkbook(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/workbook/workbook_title", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data)
          return
        }
        reject(response)          
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 특정 문제집 목차정보
  // payload : {workbook_title_id: 1}
  // response.data.data : [{
  //     "id": 1,
  //     "workbook_title_id": 1,
  //     "parent_content_id": null,
  //     "title": "1번 목차 수정함",
  //     "depth": 1,
  //     "depth_order": 1,
  //     "global_order": 1,
  //     "create_time": "2025-11-07 18:22:04.818873",
  //     "update_time": "2025-11-07 18:55:21.391786",
  //     "children": [
  //         {
  //             "id": 10,
  //             "workbook_title_id": 1,
  //             "parent_content_id": 1,
  //             "title": "1-2번 목차",
  //             "depth": 2,
  //             "depth_order": 2,
  //             "global_order": 3,
  //             "create_time": "2025-11-07 18:51:04.349913",
  //             "update_time": "2025-11-07 18:51:04.349913",
  //             "children": [
  //                 {
  //                     "id": 13,
  //                     "workbook_title_id": 1,
  //                     "parent_content_id": 10,
  //                     "title": "1-2-1번 목차",
  //                     "depth": 3,
  //                     "depth_order": 1,
  //                     "global_order": 4,
  //                     "create_time": "2025-11-07 18:54:07.141151",
  //                     "update_time": "2025-11-07 18:54:07.141151",
  //                     "children": []
  //                 },
  //             ]
  //         },
  //         {
  //             "id": 11,
  //             "workbook_title_id": 1,
  //             "parent_content_id": 1,
  //             "title": "1-3번 목차",
  //             "depth": 2,
  //             "depth_order": 3,
  //             "global_order": 6,
  //             "create_time": "2025-11-07 18:51:06.363500",
  //             "update_time": "2025-11-07 18:51:06.363500",
  //             "children": []
  //         }
  //     ]
  // }]
  getWorkbookContentList(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/workbook/workbook_content_list", {
        params: payload
      })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response.data.data)
            return
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 커스텀 문제집 목차 추가
  // payload: {
  //     "workbook_title_id": 1,
  //     "parent_content_id": 4,
  //     "title": "3-1번 목차"
  // }
  // response.data.data: {"id": 19}
  addWorkbookContent(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/workbook/workbook_content", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data)
          return
        }

        reject(response)          
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // 커스텀 문제집 목차 수정
  // payload: {"id": 14, "title": "1-2-2번 목차 수정함?"}
  editWorkbookContent(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/workbook/workbook_content", payload).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data)
          return
        }
        reject(response)          
        }).catch((error) => {
          reject(error)
        })
    })
  },

  deleteWorkbookContent(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/workbook/workbook_content", { params: { id: payload } }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data)
          return
        }
        reject(response)          
        }).catch((error) => {
          reject(error)
        })
    })
  },
  
  // ✅ [GET] 특정 목차의 스텝 리스트 불러오기
  // payload: { workbook_content_id: 13 }
  // response.data.data_list = [{ id, type, title, step_order, ... }]
  getWorkbookStepList(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/v2/workbook/workbook_step_list", { params: payload })
        .then((response) => {
          if (response.data.result === "success") {
            resolve(response.data.data || [])
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },

  //[get]스텝 상세정보 가져오기
  getWorkbookStepInfo(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v2/workbook/workbook_step_info?', {
          params: payload,
        })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  }, 
  //[post]스텝에 문제 생성
  addWorkbookQuestion(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/workbook/workbook_question', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  //[delete]스텝에 있는 문제 삭제
  deleteWorkbookQuestion(context, payload) {
    const questionId = typeof payload === 'object' ? payload.id : payload

    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v2/workbook/workbook_question', {
          params: { id: questionId },
        })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },

  //[post]스텝에 개념서 추가
  addWorkbookConceptBook(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v2/workbook/workbook_concept_book', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },

  //[delete]스텝에 있는 개념서 삭제
  deleteWorkbookConceptBook(context, payload) {
    const conceptId = typeof payload === 'object' ? payload.id : payload

    return new Promise((resolve, reject) => {
      axios
        .delete('/api/v2/workbook/workbook_concept_book', {
          params: { id: conceptId },
        })
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },

  // [PUT]스텝에 있는 문제 순서 변경
  changeWorkbookQuestionSequence(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put('/api/v2/workbook/workbook_question', payload)
        .then((response) => {
          if (response.data.result === 'success') {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },
  // ✅ [POST] 스텝 생성
  // payload: { workbook_title_content_id: 13, type: 1, title: "문제 테스트입니다22" }
  // response.data.data = { id: 1, ... }
  createWorkbookStep(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/v2/workbook/workbook_step", payload)
        .then((response) => {
          if (response.data.result === "success") {
            console.log(response)
            resolve(response.data.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },

  deleteWorkbookStep(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/api/v2/workbook/workbook_step", {
          params: { id: payload },
        })
        .then((response) => {
          if (response.data.result === "success") {
            resolve(response.data)
            return
          }
          reject(response)
        })
        .catch((error) => reject(error))
    })
  },
}
